export default (direction = 'left', speed = 50, pauseOnHover = true) => ({
  direction: direction,
  speed: speed,
  pauseOnHover: pauseOnHover,
  isPaused: false,
  animationId: null,
  currentPosition: 0,

  init() {
    const content = this.$refs.marqueeContent

    if (!content) return

    const startAnimation = () => {
      const contentWidth = content.scrollWidth / 3

      const pixelsPerSecond = speed * 2
      const pixelsPerFrame = pixelsPerSecond / 60

      const animate = () => {
        if (!this.isPaused) {
          if (this.direction === 'left') {
            this.currentPosition -= pixelsPerFrame

            if (Math.abs(this.currentPosition) >= contentWidth) {
              this.currentPosition = 0
            }
          } else {
            this.currentPosition += pixelsPerFrame

            if (this.currentPosition >= contentWidth) {
              this.currentPosition = 0
            }
          }

          content.style.transform = `translateX(${this.currentPosition}px)`
        }

        this.animationId = requestAnimationFrame(animate)
      }

      this.animationId = requestAnimationFrame(animate)
    }

    startAnimation()

    this.$el._cleanup = () => {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId)
      }
    }
  },

  pause() {
    if (this.pauseOnHover) {
      this.isPaused = true
    }
  },

  resume() {
    if (this.pauseOnHover) {
      this.isPaused = false
    }
  },

  destroy() {
    if (this.$el._cleanup) {
      this.$el._cleanup()
    }
  }
})
